module.exports = __webpack_public_path__ + "static/media/install2.7db4d246.png";